export const OnboardingStepEvents = {
  OnboardingCompleted: 'OnboardingCompleted',
  StepViewChange: 'StepViewChange',
  GoodFitSelected: 'GoodFitSelected',
  StoreSelected: 'StoreSelected',
  HazmatSelected: 'HazmatSelected',
  CantShipWithUsSelected: 'CantShipWithUsSelected',
  CostCalculatorDimensions: 'CostCalculatorDimensions',
  CostCalculatorResult: 'CostCalculatorResult'
}
